var Reverb = window.Reverb || {};

Reverb.BlockSellerAction = (function () {
  function bindSellerBlockActions() {
    $(document).on('click', 'input[data-sellerblock=true],a[data-sellerblock=true]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      showSellerBlockMessage($(this));
    });

    $(document).on('submit', 'form[data-sellerblock=true]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      showSellerBlockMessage($(this));
    });
  }

  function showSellerBlockMessage(clicked) {
    var message = $(clicked).data('sellerblock-message');
    showMessage(message);
  }

  function showMessage(message) {
    $.fancybox($('<h3>', {
      text: message,
      class: 'seller-blocked-message'
    }), {});
  }

  return {
    bindSellerBlockActions: bindSellerBlockActions,
    showMessage: showMessage
  };
})();

$(Reverb.BlockSellerAction.bindSellerBlockActions);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/block_seller_action.js